import { Calendar } from "primereact/calendar"
import { Dialog } from "primereact/dialog"
import { useRegularization } from "../../Hooks/Features/HrLens/useRegularization"
import { convertTo12HourFormat, dateConvert, timePickerMuiCss } from "../../utils/Helper"
import { Dropdown } from "primereact/dropdown"
import { TimePicker } from "@mui/x-date-pickers/TimePicker"

const RegularizationRequest = ({ regularization, handleClose, apiCall }) => {

    const { formValue, setFormValue, option, handleSubmit } = useRegularization({ regularization, handleClose, apiCall });

    return (
        <Dialog
            className='modal-xsmall'
            modal={true}
            draggable={false}
            visible={regularization?.show}
            onHide={handleClose}
            header={() => {
                return <div>Ragularization</div>
            }}
        >
            <div>
                <div className="d-flex justify-content-between my-2">
                    <div>
                        <label>Date</label>
                        <p><b>{dateConvert(regularization?.data?.day_date, "day-month-year")}</b></p>
                    </div>
                    <div>
                        <label>Shift Time</label>
                        <p><b>{convertTo12HourFormat(regularization?.data?.shift_startdate)}- {convertTo12HourFormat(regularization?.data?.shift_enddate)}</b></p>
                    </div>
                    <div>
                        <label>Tap In/Out</label>
                        <p><b>{convertTo12HourFormat(regularization?.data?.insights_starttime) || "00:00"} to {convertTo12HourFormat(regularization?.data?.insights_endtime) || "00:00"}</b></p>
                    </div>
                </div>
                <div className="d-flex gap-4 justify-content-between">
                    <div className="w45">
                        <label>Start Time</label>
                        <TimePicker value={formValue?.startTime || null} onChange={(e) => setFormValue((prev) => ({ ...prev, startTime: e }))} sx={{ ...timePickerMuiCss, backgroundColor: "var(--button-bg-color)", borderRadius: "8px", margin: "2px 2px", input: { color: "var(--text-color)" } }}
                            slotProps={{
                                textField: {
                                    label: undefined,
                                }
                            }}
                        />
                    </div>
                    <div className="w45">
                        <label>End Time</label>
                        <TimePicker value={formValue?.endTime || null} onChange={(e) => setFormValue((prev) => ({ ...prev, endTime: e }))} sx={{ ...timePickerMuiCss, backgroundColor: "var(--button-bg-color)", borderRadius: "8px", margin: "2px 2px", input: { color: "var(--text-color)" } }}
                            slotProps={{
                                textField: {
                                    label: undefined,
                                }
                            }}
                        />
                    </div>
                </div>
                <div>
                    <label>Reason</label>
                    <Dropdown
                        value={formValue?.reason}
                        onChange={(e) => setFormValue((prev) => ({ ...prev, reason: e.target.value }))}
                        placeholder="Select a Reason"
                        options={option}
                        optionLabel="reasons"
                        className="input-dd"
                        filter filterInputAutoFocus
                    />
                </div>
                {
                    formValue?.reason?.reasons?.toLowerCase() === "other" && <div className="w100 my-2">
                        <label>Remark</label>
                        <textarea value={formValue?.description} rows="2" className="form-control" onChange={(e) => setFormValue((prev) => ({ ...prev, description: e.target.value }))} style={{ resize: "none" }} />
                    </div>
                }
                <div className="d-flex justify-content-center my-2">
                    <button onClick={handleSubmit}>Submit</button>
                </div>
            </div>
        </Dialog>
    )
}

export default RegularizationRequest